import { motion } from "framer-motion";

const logos = ["Litify", "Filevine", "SmartAdvocate", "Salesforce", "RingCentral", "Five9", "Dialpad", "Zoom"];

const TrustBar = () => {
    return (
        <section data-testid="trust-bar" className="relative py-12 md:py-14 bg-[var(--cream-2)] border-y border-[var(--border)]">
            <div className="max-w-[1280px] mx-auto px-6 md:px-10">
                <p className="font-mono text-[11px] tracking-[0.18em] text-[var(--muted)] text-center mb-7 uppercase leading-[1.7]">
                    <span className="block md:inline">Native to your stack</span>
                    <span className="hidden md:inline mx-2">&middot;</span>
                    <span className="block md:inline text-[var(--ink-soft)]">Trusted across PI, mass tort &amp; estate</span>
                </p>
                <div className="relative overflow-hidden" style={{ maskImage: "linear-gradient(90deg, transparent, black 8%, black 92%, transparent)", WebkitMaskImage: "linear-gradient(90deg, transparent, black 8%, black 92%, transparent)" }}>
                    <div className="flex marquee-track gap-14 items-center whitespace-nowrap">
                        {[...logos, ...logos].map((logo, i) => (
                            <motion.div
                                key={`${logo}-${i}`}
                                whileHover={{ scale: 1.04 }}
                                className="font-display text-xl md:text-2xl text-[var(--ink-soft)] opacity-70 hover:opacity-100 transition-opacity"
                            >
                                {logo}
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrustBar;
